module.exports = __webpack_public_path__ + "static/img/character-2.cde49e0d.png";